<template>
  <div class="box" style="background-color: #FFFFFF;  height: 100%;  padding: 0 5%;">
    <!-- <BDhear :num=2></BDhear> -->
    <div style="display: flex;justify-content: space-between;">
      <div style="margin-top: 10px;margin-bottom: 0px; flex: 1.5;   display: flex;">
        <!-- 施工单位 -->
        <el-select @change="achaisd"  class="inputses" v-model="valse" placeholder="请选择施工单位">
          <el-option v-for="item in options" :key="item.unify_social_credit_code" :label="item.company_name"
            :value="item"></el-option>
        </el-select>
        <div class="casdxinzneg" style="display: flex;">
          <!-- 账号推荐人 -->
          <div style="width: 97px;height: 40px;    justify-content: flex-end;display: flex;align-items: center;
">业务员：</div>
          <el-input  style="width: 60%;" clearable v-model="xma_mobile " placeholder="请输入业务员"></el-input>
        </div>
      </div>
      <div style="flex: 1;" class="Guarantee_examine_input">
        <el-row style="display: flex;
    justify-content: right;" class="mb8">
      <el-col :span="19" class="seach">
        <el-input  placeholder="请输入机构名称"></el-input>
        <el-button type="primary" icon="el-icon-search" ></el-button>
      </el-col>
    </el-row>
        <!-- <el-input v-model="input" placeholder="请输入内容"></el-input>
        <el-button class="Sousuo" type="primary">搜索</el-button> -->
      </div>
    </div>
    <div class="Guarantee_status_box">
      <div style="display: flex;  height: 100%; justify-content: center;    align-items: center;"
 
 v-if="Bidi">
        暂无数据
      </div>
      <div v-else v-for="item in BidingDocumentList" :key="item.id" style="display: flex;flex-direction: column;"
        class="Guarantee_status">
        <div style="margin-left:20px;" class="fl">
          <div style="display: flex;    justify-content: space-between;">
            <div style="color:#333333;font-size:24px;font-weight:bold;display: inline-block;
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;">{{ item.bidding_project_name }}</div>
            <div class="Ge_box">
              <div>{{ item.bidding_type }}</div>
            </div>
          </div>
        </div>
        <div style="display: flex;" class="fl Guarantee_details">
          <div style="margin-top: 35px;margin-left: -30px;display: flex;justify-content: center;" class="fl">
            <div>
              <img src="../../assets/Guarantee/file.png" />
            </div>
            <div style="margin-left:6px" class="Guarantee_num">
              标段编号：
              {{ item.bidding_number }}
            </div>
          </div>
          <div style="margin-top: 53px;display: flex;justify-content: center;" class="fl">
            <!-- <div>
              <img src="../../assets/Guarantee/file.png" />
            </div> -->
            <!-- <div style="margin-left:6px">开标时间:{{ item.bidder_notice_time }}</div> -->
          </div>
          <div class="money">
            <div style="color:#FF184E;font-size:28px;font-weight: bold;">￥{{ item.margin_amount }}</div>
            <div style="display: flex;    justify-content: center;">
              <div class="bubble">
                <div style="margin-top:4px">项目金额</div>
              </div>
            </div>
          </div>
          <div @click="yewuren(item)"  style="margin-top: 23px;">
            <el-button v-if="!xma_mobile" disabled class="examine_btn">申请</el-button>
             <el-button v-else  class="examine_btn">申请</el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="pagination">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :page-sizes="[4, 8, 12]" :page-size="gongcheng.limit" layout="total, sizes, prev, pager, next, jumper"
        :total="total"></el-pagination>
    </div>
  </div>
</template>

<script>
// import BDhear from './BDhear.vue'
import axios from "axios";
import { concompany, bidding, generate,zhaobiao } from "@/api/system/liucheng.js";
export default {
  name: "SelectALot",
  data() {
    return {
      input: "",
      currentPage4: 1,
      xuanze: "",
      canshu: {
        offset: 0,
        limit: 4,
        keywords: "",
        user_id: sessionStorage.getItem("user_id")
      },
      total: null,
      BidingDocumentList: [],
      options: [],
      valse: "",
xma_mobile:"",
      gongcheng: {
        unify_code: "",
        offset: 0,
        limit: 4
      },
      Bidi:true,
      xastiao:false,
    };
  },
  created() {
    this.optionss();
    this.bhlistss();
  },

  methods: {
    //业务员
    yewuren(item){
     axios({
        url: "https://api.hnzyxsbh.com/dagent/baohan/mobile_exists",
        method: "post",
        // params: '必须是一个无格式对象 query参数',
        data: {
          mobile: this.xma_mobile ,
        },
        timeout: 10000,
        headers: {
          token: sessionStorage.getItem("token"),
        },
      }).then((res) => {
        if (res.data.code == 1) {
          sessionStorage.setItem("xma_mobile", this.xma_mobile);
          // this.$message.success("业务员填写成功");
          this.xastiao=true
          // this.open_buhege = false
          // this.opendsh = false;
          this.Institution(item)
        } else {
          this.$message.error(res.data.msg);
          // this.opendsh = false
        }
      });
    },
    bhlistss(){
zhaobiao(this.gongcheng).then(res => {
  if(res.data.code==1){
     this.BidingDocumentList = res.data.data.weikai;
     if(res.data.data.weikai.length!==0){
        this.Bidi=false
     }
      
        this.total = res.data.data.weikai_total;
  }else{
    
  }
       
      });
    },
    achaisd(value) {
      console.log("选择公司", value);
      this.valse = value.company_name;
      this.gongcheng.unify_code = value.unify_social_credit_code;
      // this.biddings();
    },
    // 列表详情
    biddings() {
      bidding(this.gongcheng).then(res => {
        this.BidingDocumentList = res.data.data.rows;
        this.total = res.data.data.total;
      });
    },
    // 下拉选项
    optionss() {
      var bbc = sessionStorage.getItem("user_id");
      concompany(bbc).then(res => {
        this.options = res.data.data.rows;
        console.log(res.data.data.rows);
      });
    },

    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.gongcheng.limit = val;
      this.biddings();
    },
    handleCurrentChange(val) {
      this.gongcheng.offset = parseInt(val - 1) * this.gongcheng.limit;
      console.log(`当前页: ${val}`);
      this.biddings();
    },
    Institution(item) {
    if(!this.xastiao){
         this.$message.error("请填写业务员或输入正确的业务员");
return
      }
 var timer = setInterval(() => {
     
            clearInterval(timer);
console.log("asdjasd")
      let { proid, bidding_number,purchase_person_name ,margin_amount,bidding_project_name,bid_end_time,bid_begin_time} = item;
      console.log("项目", item)
      if(this.valse==""){
  this.$message({
          showClose: true,
          message: '请选择施工单位后再进行申请。',
          type: 'warning'
        });
      }else{
         sessionStorage.setItem("proid", proid); //保函id
      sessionStorage.setItem("bidding_name", bidding_number); //项目编号
      sessionStorage.setItem("bidding_project_name", bidding_project_name); //开标日期
       sessionStorage.setItem("purchase_person_name", purchase_person_name); //招标人
        sessionStorage.setItem("bid_begin_time", bid_begin_time); //开标日期
         sessionStorage.setItem("bid_end_time", bid_end_time); //截止时间
      sessionStorage.setItem("margin_amount", margin_amount); //预算金额
      sessionStorage.setItem("unify_code", this.gongcheng.unify_code); //申请公司统一社会信信用代码
      sessionStorage.setItem("apply_company_name", this.valse); //申请公司统一社会信信用代码
      console.log("参数", item)
      // // return
      //   generate(this.gongcheng).then(res => {
      //   // this.BidingDocumentList = res.data.data.rows;
      //   // this.total = res.data.data.total;
      // });
      sessionStorage.setItem("proid", proid); //当前选择标段id，存储后跳转下一不
      // sessionStorage.setItem("bidding_name", bidding_number); //当前选择标段id，存储后跳转下一不
      this.$router.push("/Institution");
      }
      // return
      // var bcc = {
      //   typeid: "",//申请保函类型id
      //   projectid: "",//申请保函项目id
      //   companyid: "",//担保公司id
      //   ga_code: "",//渠道唯一识别码
      //   unify_code: this.gongcheng.unify_code,//申请公司统一社会信信用代码
      //   apply_company_name: this.valse,//申请公司名

      // }
           }, 500);

    }
    
  }
};
</script>

<style scoped lang="scss">
.box {
  flex: 1;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.xiayibu_btn {
  padding-top: 20px;
  padding-bottom: 40px;
  display: flex;
  justify-content: center;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
  width: 100%;
}

.Sousuo {
  height: 40px; 
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 5px;
}

.Guarantee_examine_input {
  margin-top: 13px;
  margin-bottom: 13px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
// ::v-deep .Guarantee_examine_input .el-input{
//     height: 30px !important;
//   }
//   ::v-deep .Guarantee_examine_input .el-input__inner{
//     height: 30px !important;
//     line-height: 30px !important;
//   }
.examine_btn {
  width: 143px;
  height: 47px;
  color: #1795ff;
  font-size: 21px;
}

.casdxinzneg .el-input {
  width: 230px !important;
}
.el-input {
  // width: 330px !important;
}
.bubble {
  color: #ffffff;
  font-size: 12px;
  width: 94px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 31px;
  margin-left: 20px;
  background-image: url("../../assets/Guarantee/Bubble.png");
}

.Guarantee_details {
  justify-content: space-around;
}

.Ge_box {
  width: 113px;
  height: 33px;
  border-radius: 4px;
  background-color: #1795ff;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  margin-left: 15px;
}

.Guarantee_num {
height: 48px;
    font-size: 17px;
    color: #333;
}

.Guarantee_status_box {
// padding: 0 3%;
// display: flex;
// flex-direction: column;
// justify-items: center;
// align-items: center;
// height: 57vh;
  flex: 1;
}

.Guarantee_status {
  /* width: 1400px; */
  height: 122px;
  margin-bottom: 10px;
  padding-top: 10px;
  // background-color: #d6e7f0;
  box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.16);
}
</style>



// WEBPACK FOOTER //
// src/view/BidSecurity/SelectALot.vue